import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-07e44ccb"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "overview-layout"
};
const _hoisted_2 = {
  class: "time-span"
};
const _hoisted_3 = {
  class: "general-view-box"
};
const _hoisted_4 = {
  class: "view-title-box"
};
const _hoisted_5 = {
  class: "score-span"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "score-span-unit"
}, "分", -1));
const _hoisted_7 = {
  key: 0,
  class: "itemDesc-span"
};
const _hoisted_8 = {
  class: "adv-span"
};
const _hoisted_9 = {
  class: "charts-box"
};
import qiunVueUcharts from '@qiun/vue-ucharts';

import { toRefs, computed, unref } from 'vue';
export default {
  __name: 'OverviewInfo',
  props: {
    testingResult: {
      type: Object,
      default: () => ({})
    }
  },
  setup(__props) {
    const props = __props;
    const {
      testingResult
    } = toRefs(props);
    const opts = computed(() => ({
      color: ['#FFFFFF', '#FEFF43', '#FAC858'],
      padding: [15, 10, 0, 15],
      dataLabel: false,
      dataPointShape: false,
      enableScroll: false,
      legend: {
        show: false
      },
      xAxis: {
        gridType: 'dash',
        disableGrid: false,
        disabled: true,
        dashLength: 2,
        splitNumber: 2
      },
      yAxis: {
        gridType: 'dash',
        disableGrid: true,
        disabled: true,
        dashLength: 2,
        splitNumber: 2,
        showTitle: false,
        data: [{
          min: 0,
          max: unref(testingResult).maxScore ?? 0
        }]
      },
      extra: {
        line: {
          type: 'curve',
          width: 2,
          activeType: 'hollow',
          linearType: 'custom',
          onShadow: true,
          activeType: 'solid'
        }
      }
    }));
    const chartData = computed(() => {
      const {
        minScore = 0,
        score = 0,
        maxScore = 0
      } = unref(testingResult);
      const res = {
        categories: ['最低分', '得分', '最高分'],
        series: [{
          name: '分数',
          linearColor: [[0, '#FFFFFF'], [1, '#FAC858']],
          setShadow: [minScore, score, maxScore, '#fff'],
          data: [minScore, score, maxScore]
        }]
      };
      return JSON.parse(JSON.stringify(res));
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("span", _hoisted_2, "测评时间：" + _toDisplayString(_unref(testingResult).completeTime ?? '-'), 1), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("span", _hoisted_5, _toDisplayString(_unref(testingResult).score ?? 0), 1), _hoisted_6, _unref(testingResult).showScoreDesc === 1 ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_unref(testingResult).itemDesc), 1)) : _createCommentVNode("", true), _createElementVNode("span", _hoisted_8, "群体均值：" + _toDisplayString(_unref(testingResult).norm ?? 0) + "分", 1)]), _createElementVNode("div", _hoisted_9, [_createVNode(_unref(qiunVueUcharts), {
        type: "line",
        opts: _unref(opts),
        "chart-data": _unref(chartData)
      }, null, 8, ["opts", "chart-data"])])])]);
    };
  }
};